(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypeCheckDialogController', TypeCheckDialogController);

    TypeCheckDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TypeCheck'];

    function TypeCheckDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TypeCheck) {
        var vm = this;

        vm.typeCheck = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.typeCheck.id !== null) {
                TypeCheck.update(vm.typeCheck, onSaveSuccess, onSaveError);
            } else {
                TypeCheck.save(vm.typeCheck, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:typeCheckUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
